<template>
  <div>
    <CRow>
      <CCol sm="8">
        <CCard>
          <CCardHeader>
           사용자 정보
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CInput prepend="이름" v-model="name" disabled>
                <template #append-content><CIcon name="cil-user"/></template>
              </CInput>
              <CInput type="email" v-model="email" autocomplete="email" prepend="E-mail" disabled>
                <template #append-content><CIcon name="cil-envelope-closed"/></template>
              </CInput>
              <CInput type="전화번호" v-model="phone" autocomplete="current-password" prepend="전화번호" disabled>
                <template #append-content></template>
              </CInput>
             <!-- <CInput type="" autocomplete="current-password" prepend="Password">
                <template #append-content></template>
              </CInput>-->
              <div style="display: inline-block;">
                <div class="input-group" style="margin-bottom: 1rem;">
                  <div class="input-group-prepend">
                    <span class="input-group-text">권한</span>
                    <div class="input-group-append form-control col-sm-8" style="padding: 0px;">
                      <select id="uid-utosbj1koo"  v-model="roleGroup" required="required"  class="col-sm-12" style="border: 0px solid" disabled>
                        <option value="M">마스터</option>
                        <option value="C">단체</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: inline-block;padding-left: 10px;">
                <div class="input-group-prepend" >
                  <span class="input-group-text">활성화여부</span>
                  <div class="input-group-append form-control col-sm-10" style="padding: 0px;">
                    <select id="uid-utosbj1koo"  v-model="enabledYn" required="required"  class="col-sm-12" style="border: 0px solid" disabled>
                      <option value="Y">활성</option>
                      <option value="N">비활성</option>
                    </select>
                  </div>
                </div>
              </div>
              <CInput type="textarea" autocomplete="current-password" prepend="메모" disabled>
                <template #append-content></template>
              </CInput>
              <CInput type="text" v-model="insertTime" autocomplete="current-password" prepend="등록일" disabled>
                <template #append-content></template>
              </CInput>
              <CInput type="password" v-model="password" autocomplete="current-password" prepend="비밀번호">
                <template #append-content></template>
              </CInput>
              <CInput type="password" v-model="passwordConfirm" autocomplete="current-password" prepend="비밀번호확인">
                <template #append-content></template>
              </CInput>
               <div class="form-group form-actions">
                 <div class="col-sm-0.5">
                   <CButton label=""
                            type="button"
                            style="text-align: right"
                            class="btn btn-info " @click="backHistory">뒤로가기
                   </CButton>
                   <CButton label=""
                            type="button"
                            style="text-align: right; float: right;"
                            class="btn btn-info " @click="passwordUpdate">비밀번호변경
                   </CButton>
                 </div>
              </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from "axios";
  import VueMoment from 'vue-moment'

  Vue.use(VueMoment)

  export default {
    name: 'mypage',
    components: {
    },
    data() {
      return{
        optionsRole: ['마스터', '단체'],
        optionsEnabled: ['사용', '사용중지'],
        adminItem: {},
        insertTime:'',
        enabledYn:'',
        roleGroup:'',
        phone:'',
        name:'',
        email:'',
        password:'',
        passwordConfirm:'',
      }
    },
    filters:{
      comma(val){
        return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    mounted() {
      const custId = this.$route.params.custId;

      axios.get('silver/myPage')
              .then(res => {
                console.log(res.data);
                this.name = res.data.admin.name;
                this.email = res.data.admin.email;
                this.phone = res.data.admin.phone;
                this.memo = res.data.admin.memo;
                this.roleGroup = res.data.admin.roleGroup;
                this.enabledYn = res.data.admin.enabledYn;
                this.insertTime = this.$moment(res.data.admin.insertTime).format('YYYY-MM-DD');

              })
              .catch(function(error) {
                console.log(error);
              });
    },
    methods: {
        passwordUpdate() {

          var password = this.password;
          var passwordConfirm = this.passwordConfirm;
          if(password === passwordConfirm){
            axios.post('/silver/myPage/passUpdate', {
              loginPwd: this.password,
            })
            .then(data => {
              alert("비밀번호가 변경되었습니다.");
              this.$router.push({name:"paymanagementlist"})
            })
            .catch(function (error) {
              console.log(error)
            });
          } else {
            alert("비밀번호를 확인해주세요.");
          }


        },
        backHistory() {
          this.$router.go(-1)
        }
      }

  }
</script>
